import type { BasicBottleneckResult, BottleneckNodeInput } from './contracts';
import { rankBottleneckCandidates } from './rank-candidates';
import { noBottleneckSignal, partialBottleneckCoverage, type SimulationWarning } from '../warnings';

/**
 * SPEC-009 DF-156/plan §30-33 — evaluates basic bottleneck candidates for a
 * single scenario context. Pure: takes already-resolved per-node
 * conversion/entries/exits/targetGap (the caller reads those straight off
 * `runMetricsEngine`/`calculateReverseRequirements` output — this module
 * never touches the graph or re-derives a metric).
 */
export function evaluateBasicBottlenecks(
  nodes: readonly BottleneckNodeInput[],
  scenarioContext: string,
): BasicBottleneckResult {
  const candidates = rankBottleneckCandidates(nodes);
  const warnings: SimulationWarning[] = [];

  const unranked = candidates.filter((candidate) => candidate.rankScore === null);
  if (unranked.length > 0) {
    warnings.push(noBottleneckSignal(unranked.map((candidate) => candidate.nodeId)));
  }

  const partiallyCovered = candidates.filter(
    (candidate) => candidate.rankScore !== null && candidate.evidence.length < 3,
  );
  if (partiallyCovered.length > 0) {
    warnings.push(partialBottleneckCoverage(partiallyCovered.map((candidate) => candidate.nodeId)));
  }

  return { scenarioContext, candidates, warnings };
}
